import { FC } from "react"
import { Box, Grid, Paper, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import FoSLogo from "src/app/core/components/FoSLogo"
import FoSLogoText from "src/app/core/components/FoSLogoText"

const LoginPaper: FC = ({ children }) => {
  const { t } = useTranslation("shop")

  return (
    <Box
      pt="10%"
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      pl={4}
      pr={4}
      flex={"1 0 auto"}
    >
      <Box mt={-2} mb={2}>
        <FoSLogo height={64} />
      </Box>
      <Paper
        sx={{ padding: 4, boxShadow: "16px 16px 24px rgba(0,0,0,0.05)", borderRadius: 4 }}
        elevation={0}
      >
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          flexDirection="column"
          spacing={2}
          // sx={{ maxWidth: 750 }}
        >
          <Grid item>
            <Grid container flexDirection="column" justifyContent="center" alignContent="center">
              <Grid item>
                <Typography>{t("authSignInTitle")}</Typography>
              </Grid>
              <Grid item>
                <FoSLogoText />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>{children}</Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

export default LoginPaper
